/*eslint react/no-deprecated:0*/
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import { push } from 'react-router-redux';
import FontAwesome from 'react-fontawesome';
import { Row, Col, Container } from 'reactstrap';

import ItemListC from './itemList';
import * as paradasActions from 'modules/paradas/action';
import * as generalActions from 'modules/general/action';
import { EliminarConfirmacionC } from 'modules/general/component';
import { checkPermissions } from 'core/generalFunctions';

moment.locale('es');

@connect((store) => ({
  userRoles: store.getIn(['user', 'roles']),
  paradasList: store.getIn(['paradas', 'lista']),
  eliminarId: store.getIn(['paradas', 'eliminarId']),
  paradasSugeridas: store.getIn(['paradas', 'paradasSugeridas']),
}))
export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tabSelect: 'paradas', eliminarId: false, creadaByChofer: false };
  }
  componentDidMount() {
    const { dispatch } = this.props;
    if (checkPermissions(['admin', 'administrador_paradas'])) {
      dispatch(paradasActions.get());
      dispatch(paradasActions.getSugeridas());
    }
    this.props.dispatch(generalActions.dashboard_changeTitle('PARADAS'));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.userRoles && this.props.userRoles != nextProps.userRoles && checkPermissions(['admin', 'administrador_paradas'])) {
      this.props.dispatch(paradasActions.get());
      this.props.dispatch(paradasActions.getSugeridas());
    }
  }
  delete = (parada) => {
    this.setState({
      eliminarId: parada ? parada.id : false,
      creadaByChofer: Boolean(parada && parada.creadaByChofer),
    });
  };
  confirmDelete = () => {
    this.props.dispatch(paradasActions.delete_(this.state.eliminarId, this.state.creadaByChofer));
    this.delete();
  };
  add = () => this.props.dispatch(push('/dashboard/paradas/add/new'));
  crearSimilar = (parada) => {
    this.props.dispatch(paradasActions.setState({ parada }));
    this.props.dispatch(push('/dashboard/paradas/add/new'));
  };
  componentWillUnmount() {
    //this.props.dispatch(paradasActions.clear('all'));
  }
  render() {
    const { paradasList, paradasSugeridas } = this.props;
    let ejecutarMenu = false;
    return (
      <Container>
        <Col md={{ size: 8, offset: 2 }}>
          <MaterialUI.Tabs value={this.state.tabSelect} onChange={(tabSelect) => this.setState({ tabSelect })}>
            <MaterialUI.Tab label="Listado" value="paradas">
              <MaterialUI.Paper zDepth={2} className="container">
                <Row>
                  <Col md="12">
                    <MaterialUI.List className="noPadding dividerList">
                      {paradasList.map((parada) => (
                        <ItemListC key={parada.get('id')} parada={parada.toJS()} delete={this.delete} crearSimilar={this.crearSimilar} />
                      ))}
                    </MaterialUI.List>
                  </Col>
                </Row>
              </MaterialUI.Paper>
            </MaterialUI.Tab>
            <MaterialUI.Tab label="Sugeridas por conductor" value="paradasSugeridas">
              <MaterialUI.Paper zDepth={2} className="container">
                <Row>
                  <Col md="12">
                    <MaterialUI.List className="noPadding dividerList">
                      {paradasSugeridas.map((parada) => (
                        <ItemListC isSugerida={true} key={parada.get('id')} parada={parada.toJS()} delete={this.delete} crearSimilar={this.crearSimilar} />
                      ))}
                    </MaterialUI.List>
                  </Col>
                </Row>
              </MaterialUI.Paper>
            </MaterialUI.Tab>
          </MaterialUI.Tabs>
        </Col>
        {checkPermissions(['admin', 'administrador_paradas']) && (
          <MaterialUI.FloatingActionButton className="bottonFlotanteAdd" onTouchTap={this.add}>
            <FontAwesome name="plus" />
          </MaterialUI.FloatingActionButton>
        )}
        <EliminarConfirmacionC eliminarId={this.state.eliminarId} confirmar={this.confirmDelete} cancelar={this.delete} />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/paradas/components/main.js